import store from '@/store'

// Stripe publishable test key
export const STRIPE_API_VERSION = process.env.VUE_APP_STRIPE_API_VERSION
export let stripe
export let stripeCard

// create instance of Stripe object
export function initStripe(pk, language) {
  const stripeClient = window.Stripe(pk, {
    apiVersion: STRIPE_API_VERSION,
    locale: supportedLanguages[(language && language.toLowerCase()) || 'en'],
  })
  const elements = stripeClient.elements()
  stripeCard = elements.create('card', {style: baseStyle})
  stripe = stripeClient
}

// create instance of Elements (pre-built UI components) to collect payment info

// custom styling passed to options when creating an Element
const baseStyle = {
  base: {
    color: '#32325d',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#aab7c4',
    },
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a',
  },
}

const supportedLanguages = {
  es_es: 'es',
  en_us: 'en',
}

// create instance of card element with styling
// export to be used in StripeForm.vue
